import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormCertificatesAnpr } from 'system/pages/certificates-anpr/list/types';
import { DatePicker } from '@mui/lab';

interface FiltersCertificatesAnprProps {
  filtersCertificateForm: FormikProps<FiltersFormCertificatesAnpr>;
}

const FiltersCertificatesAnpr = ({
  filtersCertificateForm,
}: FiltersCertificatesAnprProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificates-anpr-content"
        id="panel-certificates-anpr-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filtersCertificateForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="ID Certificato"
                label="ID Certificato"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersCertificateForm.values.code}
                onChange={filtersCertificateForm.handleChange}
                error={
                  filtersCertificateForm.touched.code && Boolean(filtersCertificateForm.errors.code)
                }
                helperText={filtersCertificateForm.errors.code}
                inputProps={{
                  maxLength: '14',
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Alias"
                label="Alias"
                id="alias"
                name="alias"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersCertificateForm.values.alias}
                onChange={filtersCertificateForm.handleChange}
                error={
                  filtersCertificateForm.touched.alias &&
                  Boolean(filtersCertificateForm.errors.alias)
                }
                helperText={filtersCertificateForm.errors.alias}
                inputProps={{
                  maxLength: '14',
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data inizio validità"
                aria-label="Data inizio validità"
                value={filtersCertificateForm.values.startValidityDate || null}
                onChange={(date) => filtersCertificateForm.setFieldValue('startValidityDate', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="startValidityDate"
                    error={
                      filtersCertificateForm.touched.startValidityDate &&
                      Boolean(filtersCertificateForm.errors.startValidityDate)
                    }
                    helperText={filtersCertificateForm.errors.startValidityDate}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data fine validità"
                aria-label="Data fine validità"
                value={filtersCertificateForm.values.endValidityDate || null}
                onChange={(date) => filtersCertificateForm.setFieldValue('endValidityDate', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="endValidityDate"
                    error={
                      filtersCertificateForm.touched.endValidityDate &&
                      Boolean(filtersCertificateForm.errors.endValidityDate)
                    }
                    helperText={filtersCertificateForm.errors.endValidityDate}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filtersCertificateForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersCertificatesAnpr.displayName = 'Filters Certificate Anpr component';

export default FiltersCertificatesAnpr;
